import { render, staticRenderFns } from "./CabecalhoPergunta.vue?vue&type=template&id=c30a2636&scoped=true"
import script from "./CabecalhoPergunta.vue?vue&type=script&lang=js"
export * from "./CabecalhoPergunta.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoPergunta.vue?vue&type=style&index=0&id=c30a2636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30a2636",
  null
  
)

export default component.exports